import { render } from "./ClientInfoComponent.vue?vue&type=template&id=36951356"
import script from "./ClientInfoComponent.vue?vue&type=script&lang=js"
export * from "./ClientInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__